import './src/vaadin-text-field.js';

export * from './src/vaadin-text-field.js';
